import React from "react";

import {
	Link
} from "gatsby";

export default class Navbar extends React.Component {
	render() {
		return (
			<nav class="navbar navbar-expand-lg navbar-light">
			    <div class="container">
			      <Link className="navbar-brand" to="/">
			        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="30px" height="30px" viewBox="0 0 108 108" enable-background="new 0 0 108 108">
			          <path fill="#231F20" d="M54,0H0v53.302l17.514-17.513V2.919h21.892c28.168,0,51.081,22.914,51.081,51.081
				c0,28.168-22.913,51.081-51.081,51.081H17.514V56.432L0,73.945V108h54c29.775,0,54-24.225,54-54C108,24.224,83.775,0,54,0z
				 M2.919,46.256V2.919h11.676v31.662L2.919,46.256z M2.919,105.081V75.153l11.676-11.676v41.604H2.919z M57.22,104.976
				C78.268,97.6,93.405,77.535,93.405,54S78.268,10.4,57.22,3.024C83.893,4.69,105.081,26.916,105.081,54
				C105.081,81.085,83.893,103.31,57.22,104.976z" />
			        </svg>

			      </Link>
			      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
			        <span class="navbar-toggler-icon"></span>
			      </button>
			      <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
			        <div class="navbar-nav">
			          <Link className="nav-link" to="/" activeClassName="active">Home</Link>
			          <Link className="nav-link" to="/learn" activeClassName="active">Learn</Link>
			          <a class="nav-link" href="https://t.me/ducatofficial" target="_blank" rel="noopener noreferrer">Community</a>
			          <Link to="/dashboard" className="nav-link" activeClassName="active">Dashboard</Link>
			          <Link className="nav-link" to="/stake" activeClassName="active">Stake</Link>
			        </div>
			      </div>
			    </div>
		  	</nav>
		)
	}
}